// extracted by mini-css-extract-plugin
export default {"categoryBlock":"CategoryRating_categoryBlock__VwkwP","category":"CategoryRating_category__rDq4V","buttonMore":"CategoryRating_buttonMore__428+L","menu":"CategoryRating_menu__kHP4t"};